import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Formik } from 'formik'
import styled from 'styled-components'

import IsomorphicContext from '../../../contexts/IsomorphicContext'
import FormStatus from '../../ui/FormStatus/FormStatus'
import Icon from '../../ui/Icon/Icon'

const CheckIcon = styled.div`
  color: #ffffff;
  border: 0;
  background-color: var(--color-primary);
  font-size: 25px;
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 100%;
  outline: none;
  position: relative;

  > svg {
    vertical-align: baseline;
    min-width: 0.6em;
    height: 0.6em;
    position: absolute;
    top: 0.2em;
    left: 0.13em;
    font-size: 22px;
    stroke-width: 3px;
  }
`

class AccessibleForm extends React.Component {
  state = {
    jsEnabled: false,
  }

  componentDidMount() {
    this.setState({
      jsEnabled: true,
    })
  }

  render() {
    const {
      method,
      action,
      component: Component,
      render,
      disabled,
      componentProps,
      validate,
      forwardedRef,
      isContactUs,
      ...theProps
    } = this.props
    const { jsEnabled } = this.state

    return (
      <IsomorphicContext.Consumer>
        {server => (
          <Formik
            ref={forwardedRef}
            {...theProps}
            validate={validate}
            render={(...args) => {
              const [formikProps, ...theArgs] = args

              const { isValid, status = {}, ...theFormikProps } = formikProps

              const { query } = server
              const serverStatus = {}

              if (query) {
                serverStatus.message = query.message
              }

              const trueIsValid = !jsEnabled || isValid

              const trueFormikProps = {
                ...theFormikProps,
                // we assume everything is valid in the client when it is pure
                // server-side because the validation happens in the proxy server
                isValid: trueIsValid, // todo correct way of setting isValid
                status: !jsEnabled ? serverStatus : status,
              }

              if (Component) {
                return (
                  <>
                    <div
                      className={
                        status.message && isContactUs && 'messageContent'
                      }
                    >
                      <FormStatus variant={status.error ? 'error' : 'message'}>
                        {status.error || status.message}
                      </FormStatus>
                      {status.message && isContactUs && (
                        <div
                          style={{
                            position: 'absolute',
                            top: '0.55rem',
                            right: '1rem',
                          }}
                        >
                          <CheckIcon>
                            <Icon name="check" />
                          </CheckIcon>
                        </div>
                      )}
                    </div>
                    <Component
                      {...componentProps}
                      {...trueFormikProps}
                      method={method}
                      action={action}
                      disabled={disabled}
                    />
                  </>
                )
              }

              if (render) {
                return render(trueFormikProps, ...theArgs)
              }

              return null
            }}
          />
        )}
      </IsomorphicContext.Consumer>
    )
  }
}

AccessibleForm.defaultProps = {
  method: 'get',
  action: null,
  component: null,
  componentArgs: {},
  render: null,
  validate: null,
}

AccessibleForm.propTypes = {
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
  component: PropTypes.func,
  componentArgs: PropTypes.object,
  render: PropTypes.func,
  validate: PropTypes.func,
  initialValues: PropTypes.shape().isRequired,
  onSubmit: PropTypes.func.isRequired,
  isContactUs: PropTypes.bool,
}

export default React.forwardRef((props, ref) => {
  return <AccessibleForm {...props} forwardedRef={ref} />
})
